
import Home2 from '../views/InternetBigData/HomeView2.vue'


export default [
  {
    path:'/home2',
    component:Home2,
    redirect:'/internet',
    children:[
      {  //互联网大数据
        path:'/internet',
        name:'internet',
        component:()=>import('../views/InternetBigData/InternetIndex.vue'),
        meta:{
          title:'互联网大数据页面'
     }
     
      },
      { //健康大数据
        path:'/health',
        name:'health',
        component:()=>import('../views/InternetBigData/HealthView.vue'),
        meta:{
          title:'健康大数据页面'
     }
      },
      { //常见病大数据
        path:'/commondis',
        name:'commondis',
        component:()=>import('../views/InternetBigData/CommonDiseases/CommonIndex.vue'),
        meta:{
          title:'常见病大数据页面'
     }
      },
      { //常见病大数据2
        path:'/commondis2',
        name:'commondis2',
        component:()=>import('../views/InternetBigData/CommonDiseases/CommonIndex2.vue'),
        meta:{
          title:'常见病大数据页面'
     }
      },
      { //中医体质大数据
        path:'/tcmconst',
        name:'tcmconst',
        component:()=>import('../views/InternetBigData/TcmConstitution.vue'),
        meta:{
          title:'中医体质大数据页面'
     }
      },
      { //感冒气象指数
        path:'/weathercold',
        name:'weathercold',
        component:()=>import('../views/InternetBigData/WeatherCold.vue'),
        meta: {
          title: '感冒气象指数页面',

        },
      },
  
      {//健康全息档案
        path:'/holohealth',
        name:'holohealth',
        component:()=>import('../views/InternetBigData/HoloHealth/HoloIndex.vue'),
        meta:{
          title:'健康全息档案页面'
     }
      },
       {//健康全息档案
        path:'/holohealth2',
        name:'holohealth2',
        component:()=>import('../views/InternetBigData/HoloHealth/HoloIndex2.vue'),
        meta:{
          title:'健康全息档案页面'
     }
      },
      { //问诊实时动态
        path:'/intreatment',
        name:'intreatment',
        component:()=>import('../views/InternetBigData/InTreatment.vue'),
        meta:{
          title:'问诊实时动态页面'
     }
      }
    ]
  }
]


